const region = "us-east-1";

const staging = {
	appSettingsData: {
		BuyerCognitoGroup: "wl-stg-procurement-portal-buyers",
		SupplierCognitoGroup: "wl-stg-procurement-portal-suppliers",
		federatedIDPProvider: "wl-stg-procurement-portal-idp"
	},
	amplify_config: {
		Auth: {
			Cognito: {
				userPoolId: "us-east-1_1Obyj5jP5",
				userPoolClientId: "m9brispk49a5tqs4bc73tb78o",
				loginWith: {
					oauth: {
						domain: "wl-stg-procurement-portal.auth.us-east-1.amazoncognito.com",
						scopes: [],
						redirectSignIn: [
							"https://wl-stg-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						redirectSignOut: [
							"https://wl-stg-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						responseType: "code"
					}
				}
			}
		},
		API: {
			REST: {
				print: {
					endpoint: "https://api.wl-stg-procurement-portal.com/print",
					region: region
				}
			}
		}
	}
};

export default staging;
